import { Common, device } from '@stockbit/ui';
import {
  SIDE_WIDGET_OPENED_WIDTH,
  SIDE_WIDGET_TOOLBAR_WIDTH,
} from 'global/MainLayout/styled';
import styled, { css } from 'styled-components';

const { Button, Text, Modal: BaseModal } = Common;

const ChartbitWrapper = styled.div`
  height: 100vh;
  position: relative;

  /* article > div > div {
    height: 100vh !important;
  } */
`;

interface ChartbitLayoutWrapperProps {
  isSideWidgetOpen: boolean;
}

const ChartbitLayoutWrapper = styled.div<ChartbitLayoutWrapperProps>`
  width: 100%;
  position: relative;

  @media ${device.tablet} {
    width: calc(100% - ${SIDE_WIDGET_TOOLBAR_WIDTH});

    ${({ isSideWidgetOpen }) =>
      isSideWidgetOpen &&
      css`
        width: calc(100% - ${SIDE_WIDGET_OPENED_WIDTH}) !important;
      `}
  }
`;

const MyInvestmentWrapper = styled.div<{
  show: boolean;
  right: number;
}>`
  display: none;
  position: absolute;
  top: 42px;
  right: ${({ right }) => `${right}px`};
  z-index: 1;

  @media ${device.tablet} {
    display: ${({ show }) => (show ? 'block' : 'none')};
  }

  & > a > div {
    margin-bottom: 0;
  }
`;

export const MaintenanceContainer = styled.div<{ background: string }>`
  height: 100vh;
  background-color: ${(props) => props.background};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction column;
  padding: 20px;

  img {
    width: 120px;
    margin-bottom: 10px;
  }

  @media ${device.tablet} {
    img {
      width: 160px;
    }
  }

  @media screen and (max-width: 450px) {
    img {
      width: 120px !important;
    }
    p:first-of-type {
      font-size: 16px;
    }
    p:nth-of-type(2){
      font-size: 12px
    }
  }
`;

export const MaintenanceImage = styled(Text)`
  font-size: 16px;
  margin-bottom: 8px;

  @media ${device.tablet} {
    font-size: 24px;
    margin-bottom: 10px;
  }
`;

export const MaintenanceTitle = styled(Text)`
  font-size: 16px;
  margin-bottom: 8px;
  font-weight: 700;

  @media ${device.tablet} {
    font-size: 24px;
    margin-bottom: 10px;
  }
`;

export const MaintenanceDesc = styled(Text)`
  font-size: 14px;
  margin-bottom: 0;
  max-width: 280px;

  @media ${device.tablet} {
    font-size: 16px;
    max-width: unset;
  }
`;

export const MaintenanceBackButton = styled(Button)`
  padding: 12px 20.5px;
  border-radius: 100px;
  margin-top: 30px;
  display: none;

  @media ${device.tablet} {
    display: flex;
  }
`;

export const MaintenanceModal = styled(BaseModal)`
  .ant-modal-content {
    border-radius: 3px;
    background-color: ${({ theme }) => theme.color.modals.surfaceDefault};
  }
  .ant-modal-header {
    background-color: ${({ theme }) => theme.color.modals.surfaceDefault};
  }
  .ant-modal-close {
    color: ${({ theme }) => theme.color.text.primary};
  }
  @media screen and (max-width: 700px) {
    width: 335px !important;

    .ant-modal-title div {
      height: unset !important;
      padding-bottom: 12px !important;
      p {
        font-size: 16px;
        line-height: 22px;
        width: 267px;
      }
    }

    .ant-modal-body div {
      padding-bottom: 20px !important;
      p {
        font-size: 13px;
      }
    }
  }
`;

export const ErrorContainer = styled.div`
  height: 100vh;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px;

  @media ${device.tablet} {
    img {
      width: 223px;
      height: 167px;
    }
  }
`;

export const ErrorDesc = styled(Text)`
  font-size: 14px;
  margin-top: 10px;
  max-width: 319px;

  @media ${device.tablet} {
    font-size: 18px;
    font-family: var(--font-bold);
  }
`;

export const ErrorRetryButton = styled(Button)`
  padding: 12px 20.5px;
  border-radius: 100px;
  margin-top: 30px;
  display: flex;
`;

// eslint-disable-next-line import/prefer-default-export
export { ChartbitWrapper, ChartbitLayoutWrapper, MyInvestmentWrapper };
